// extracted by mini-css-extract-plugin
export default {"icon":"Item_icon__+lFsj","audioOverlay":"Item_audioOverlay__7DAsp"};